/* eslint-disable @typescript-eslint/no-explicit-any */
// 热力图
// 饼图
import '@patsnap-ui/icon/assets/solid/ChartDonut2.svg'
// 双线
import '@patsnap-ui/icon/assets/solid/ChartDouble.svg'
import '@patsnap-ui/icon/assets/solid/ChartHeatmap.svg'
// 水平柱子
import '@patsnap-ui/icon/assets/solid/ChartHorizontal.svg'
// 单线
import '@patsnap-ui/icon/assets/solid/ChartSingle.svg'
// 牛眼图
import '@patsnap-ui/icon/assets/solid/ChartSun.svg'
// 垂直柱子
import '@patsnap-ui/icon/assets/solid/ChartVertical.svg'
// 表格
import '@patsnap-ui/icon/assets/solid/ContentFormatingTable.svg'
// 世界地图
import '@patsnap-ui/icon/assets/solid/global.svg'
// 3D气泡图
import '@patsnap-ui/icon/assets/solid/Insights3DBubble.svg'
// 折柱混合土
import '@patsnap-ui/icon/assets/solid/InsightsCombinationchart.svg'
// 关系图
import '@pharmsnap/shared/assets/icon-svg/relationship.svg'
import { GChartTypeButton } from '@pharmsnap/shared/src/components'
import { useLocale } from '@pharmsnap/shared/src/composition'
import { defineComponent, PropType } from '@vue/composition-api'
import { IAnalysisDisplayIconType, IAnalysisDisplayOptionItem } from '../../type'

export const BAnalysisChartDisplaySwitch = defineComponent({
  name: 'BAnalysisChartDisplaySwitch',
  props: {
    options: {
      type: Array as PropType<Array<IAnalysisDisplayOptionItem>>,
      required: true,
      default: () => [],
    },
    value: {
      type: String as PropType<string>,
    },
  },
  setup(props, { emit }) {
    const { tsText } = useLocale()
    const handleChange = (value: string) => {
      emit('input', value)
    }
    const iconMap: Record<IAnalysisDisplayIconType, { icon: string; desc: string }> = {
      heatmap: { icon: 'SolidChartHeatmap', desc: tsText({ cn: '热力图', en: 'Heat Map', jp: 'ヒートマップ' }) },
      pie: { icon: 'SolidChartDonut2', desc: tsText({ cn: '饼图', en: 'Pie Chart', jp: '円グラフ' }) },
      'single-line': { icon: 'SolidChartSingle', desc: tsText({ cn: '曲线图', en: 'Curve Chart', jp: '折れ線グラフ' }) },
      'multi-line': { icon: 'SolidChartDouble', desc: tsText({ cn: '曲线图', en: 'Curve Chart', jp: '折れ線グラフ' }) },
      'horizontal-bar': { icon: 'SolidChartHorizontal', desc: tsText({ cn: '柱状图', en: 'Column Chart', jp: '棒グラフ' }) },
      'vertical-bar': { icon: 'SolidChartVertical', desc: tsText({ cn: '柱状图', en: 'Column Chart', jp: '棒グラフ' }) },
      relation: { icon: 'Relationship', desc: tsText({ cn: '关系图', en: 'Relation', jp: '関係図' }) },
      global: { icon: 'SolidGlobal', desc: tsText({ cn: '世界地图', en: 'World Map', jp: '世界地図' }) },
      table: { icon: 'SolidContentFormatingTable', desc: tsText({ cn: '表格', en: 'Table', jp: 'テーブル' }) },
      'line-bar': { icon: 'SolidInsightsCombinationchart', desc: tsText({ cn: '折柱图', en: 'Column Chart', jp: '複合グラフ' }) },
      'bull-eye': { icon: 'SolidChartSun', desc: tsText({ cn: '牛眼图', en: 'Bullseye Chart', jp: 'ブルズアイチャート' }) },
      'multi-pie-doughnut': { icon: 'SolidInsights3DBubble', desc: tsText({ cn: '点阵图', en: 'Bitmap', jp: 'ドットチャート' }) },
    }

    return {
      iconMap,
      handleChange,
    }
  },
  render() {
    return (
      <div class="inline-flex items-center gap-1">
        {this.options.map((item, index) => (
          <GChartTypeButton
            icon={this.iconMap[item.type].icon}
            text={this.iconMap[item.type].desc}
            active={item.value === this.value}
            onClick={() => this.handleChange(item.value)}
          ></GChartTypeButton>
        ))}
      </div>
    )
  },
})
